import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuSitePaiListDTO } from '../../../../../typesSite/menuPrincipalSite/MenuSiteListDTO';

interface MenuPrincipalSiteState {  
  layout: 'site' | 'escolaLegislativo';
  menu: MenuSitePaiListDTO[];
}

const initialState: MenuPrincipalSiteState = {
  layout: 'site', // valor inicial
  menu: []
};

const menuPrincipalSiteSlice = createSlice({
  name: 'menuPrincipalSite',
  initialState,
  reducers: { 
    setMenu: (state, action: PayloadAction<MenuSitePaiListDTO[]>) => {
      state.menu = action.payload;
    },
    setMenuLayout: (state, action: PayloadAction<'site' | 'escolaLegislativo'>) => {
      state.layout = action.payload;
    }
  }
});

export const { setMenu, setMenuLayout } = menuPrincipalSiteSlice.actions;

export default menuPrincipalSiteSlice.reducer;
